<template>
  <div class="redact-card-container">
    <v-toolbar class="redact-card-header" flat density="compact">
      <v-toolbar-title class="mx-4 my-3">
        <div class="d-flex align-center justify-space-between">
          <slot name="title" />
        </div>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text class="ma-4 pa-0 overflow-y-auto">
      <slot name="content" />
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'PdfRedactingPanelWrapper',
}
</script>

<style scoped>
  .redact-card-container {
    border-radius: 8px;
    border: 1px solid rgb(var(--v-theme-grey-100));
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .redact-card-header {
    border-radius: 8px 8px 0 0;
    background-color: rgb(var(--v-theme-grey-25));
    border-bottom: 1px solid rgb(var(--v-theme-grey-100));
  }
</style>
